// Phase 3D / Iter84 — In-memory market snapshot context.
//
// Lifts the latest snapshot built by `MarketSnapshotBuilderTile`
// into a shared React in-memory store so the five module scanner
// panels can offer a "Use Fresh Snapshot" source mode.
//
// HARD CONSTRAINTS:
//  * In-memory only. No localStorage, no sessionStorage, no
//    IndexedDB, no cookies, no URL params, no backend persistence.
//  * No `useEffect` of any kind in this provider — the snapshot
//    lives only for the lifetime of the React tree.
//  * No outbound HTTP. The provider is a pure state container.

import React, { createContext, useContext, useMemo, useState } from "react";

const MarketSnapshotContext = createContext({
  snapshot: null,
  request: null,
  setSnapshot: () => {},
});

export function MarketSnapshotProvider({ children }) {
  const [snapshot, setSnapshotState] = useState(null);
  const [request, setRequestState] = useState(null);

  const setSnapshot = (nextSnapshot, nextRequest) => {
    setSnapshotState(nextSnapshot || null);
    setRequestState(nextRequest || null);
  };

  const value = useMemo(
    () => ({ snapshot, request, setSnapshot }),
    [snapshot, request]
  );

  return (
    <MarketSnapshotContext.Provider value={value}>
      {children}
    </MarketSnapshotContext.Provider>
  );
}

export function useMarketSnapshot() {
  return useContext(MarketSnapshotContext);
}
